import script from "./WCAddToListModernCardButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WCAddToListModernCardButton.vue?vue&type=script&setup=true&lang=js"

import "./WCAddToListModernCardButton.vue?vue&type=style&index=0&id=ca3fba0e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca3fba0e"]])

export default __exports__